// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV === 'development') {
  // eslint-disable-next-line
  window.eventEmitter = {};
  // eslint-disable-next-line
  window.eventEmitter.on = () => {return; };
}

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#games-section');
